/*
  WARNING: Stage option will redirect all requests and authorizations to stage env
*/

const STAGE = false;
const DEV = process.env.NODE_ENV === 'development';

export const meta = {
  appAlias: 'vimeo-gallery',
  appName: 'Vimeo Gallery',
  apiUrl: 'https://storage.elfsight.com/api/vimeo',
  stage: STAGE && DEV
};
